import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  ogType = 'website',
  noindex = false
}) => {
  const siteTitle = 'Foulées Vertes';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Spécialiste Running, Trail & Triathlon`;
  const defaultDescription = "Spécialiste running, trail et triathlon à Clermont-Ferrand. Analyse de foulée unique en France avec technologie Footscan.";
  const defaultKeywords = "running, trail, triathlon, chaussures de course, analyse de foulée, Clermont-Ferrand, Auvergne";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content={ogType} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Canonical */}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default SEO;